import { Route, Routes } from "@angular/router";

export function normalizeRoutePaths(routes: Routes): Routes {
  return routes.reduce((acc: Routes, route: Route) => {
    acc.push(...normalizeRoutePath(route));
    return acc;
  }, []);
}

function normalizeRoutePath(route: Route): Route[] {
  const normalizedRoute: Route = { ...route };

  if (normalizedRoute.children?.length) {
    normalizedRoute.children = normalizeRoutePaths(normalizedRoute.children);
  }

  const result: Route[] = [normalizedRoute];

  if (typeof normalizedRoute.path !== "string" || normalizedRoute.path === "**") {
    return result;
  }

  const lowerCasePath = normalizedRoute.path.toLowerCase();
  if (lowerCasePath !== normalizedRoute.path) {
    result.push({
      ...normalizedRoute,
      path: lowerCasePath,
    });
  }

  return result;
}
